import { Link } from '@mui/material';
import { type ForwardedRef, forwardRef } from 'react';

import type { ExtraProps } from './types.js';

export const MarkdownLink = forwardRef<HTMLAnchorElement, ExtraProps>((props, ref) => {
  const { node, ...rest } = props;
  return (
    <Link
      ref={ref as ForwardedRef<HTMLAnchorElement>}
      {...rest}
      target="_blank"
      rel="noopener noreferrer"
    />
  );
});
MarkdownLink.displayName = 'MarkdownLink';
